<template>
  <div>
    <div class="mt-3">
      <v-card max-width="800" class="ma-auto">
        <v-img src="https://blog.cactusjack.top/upload/2022/09/5XxoWR.png" aspect-ratio="3"
               class="white--text align-end">
          <v-card-title>
            更新日志
          </v-card-title>
        </v-img>
        <v-card-text>
          <v-timeline align-top dense>
            <v-timeline-item
                color="blue darken-1"
                small
                v-for="(item,index) in resultData"
                :key="index"
            >
              <v-card elevation="5">
                <v-card-title>
                  <v-container>
                    <v-row>
                      <v-col cols="6">
                        {{ item.versions }}
                      </v-col>
                      <v-col class="text-right text-caption"
                             cols="6">
                        {{ item.creationDate }}
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <div v-for="(notice,index) in item.noticeList" class="ma-3" :key="index">
                    <!--                    <v-row justify="space-between" class="ma-1">-->
                    <!--                      <v-col cols="7" class="text-truncate">-->

                    <!--                        <v-icon :color="select(notice.type).type">-->
                    <!--                          -->
                    <!--                        </v-icon>-->
                    <span>
                      {{ select(notice.type).icon }}
                    </span>
                    <span>
                      {{ select(notice.type).label }} :
                    </span>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                            <span

                                v-bind="attrs"
                                v-on="on"
                                v-html="notice.text"
                            ></span>
                      </template>
                      <span v-html="notice.text"></span>
                    </v-tooltip>
                    <!--                      </v-col>-->
                    <!--                      <v-col-->
                    <!--                          class="text-right text-truncate"-->
                    <!--                          cols="5"-->
                    <!--                      >-->
                    <!--                        {{ notice.title }}-->
                    <!--                      </v-col>-->
                    <!--                    </v-row>-->
                    <!--                    <v-divider></v-divider>-->
                  </div>
                </v-card-text>
              </v-card>
            </v-timeline-item>

          </v-timeline>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import {noticeTimeline} from "@/api/resources/notice";
import {mapMutations} from 'vuex'

export default {
  name: "notice",
  computed: {},
  data: () => ({
    resultData: [],
    typeList: [
      {
        "value": 1,
        "label": "新增",
        "type": "success",
        "icon": "🧐"
      },
      {
        "value": 2,
        "label": "删除",
        "type": "error",
        "icon": "🤏"
      },
      {
        "value": 3,
        "label": "修复",
        "type": "warning",
        "icon": "👾"
      }
    ]
  }),
  mounted() {
    this.findNotice()
  },
  methods: {
    ...mapMutations(['setLoading', 'clearLoading']),
    findNotice() {
      this.setLoading()
      noticeTimeline().then(req => {
        this.resultData = req.data.data;
      }).finally(() => {
        this.clearLoading()
      });
    },
    select(val) {
      let result = this.typeList.find(item => item.value === val);
      if (!result) return val;
      return result;
    },
  }
}
</script>

<style scoped>

</style>